import { render } from "./AiImagesLibraryDialog.vue?vue&type=template&id=2678df0a&scoped=true"
import script from "./AiImagesLibraryDialog.vue?vue&type=script&lang=js"
export * from "./AiImagesLibraryDialog.vue?vue&type=script&lang=js"

import "./AiImagesLibraryDialog.vue?vue&type=style&index=0&id=2678df0a&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2678df0a"]])

export default __exports__